import Services from './services';
import Profile from './profile';
import Bookings from './bookings';
import Routes from './routes';
import Organisations from './organisations';
import Trips from './trips';

// eslint-disable-next-line import/no-anonymous-default-export
export default { Services, Profile, Bookings, Routes, Organisations, Trips };
